<template>
  <video-player
    v-if="playerInitialized"
    :options="playerOptions"
    :playsinline="true"
    @ready="onPlayerReady">
  </video-player>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import VideoPlayer from '@nsftx/games-visualization-sdk/src/components/VideoPlayer';
import { getApiRoute } from '@nsftx/games-visualization-sdk/config';

String.prototype.supplant = function (o) {
  return this.replace(
    /{([^{}]*)}/g,
    function (a, b) {
      var r = o[b];
      return typeof r === 'string' || typeof r === 'number' ? r : a;
    }
  );
};

export default {
  name: 'StreamPlayer',
  components: {
    VideoPlayer,
  },

  data() {
    return {
      playerInitialized: false,
      currentTech: '',
      player: null,
      type: 'web',
      page: window.location.href,
      playerOptions: {
        width: window.innerWidth,
        height: window.innerHeight,
        autoplay: false,
        loop: false,
        muted: true,
        language: 'en',
        controls: false,
        techOrder: ['flash', 'html5'],
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        sources: [],
        poster: require('../assets/bg.png'),
      },
    };
  },

  computed: {
    ...mapGetters([
      'product',
      'language',
      'streamConfig',
    ]),
  },

  methods: {
    getStreamUrl() {
      const { sources } = this.streamConfig;

      if (sources) {
        return this.getStreamToken()
          .then((response) => {
            sources.forEach((sourceItem) => {
              sourceItem.src = sourceItem.protocol
                + this.streamConfig.origin[this.product.environment]
                + sourceItem.path.supplant({
                  company: this.product.company,
                  streamName: `${this.streamConfig.name}_${this.streamConfig.resolution.medium}`,
                  token: response.data.token,
                  page: this.page,
                });
            });

            return this.parseStreamSources(sources);
          });
      }
    },
    getStreamToken() {
      const platformApi = this.product.server || getApiRoute('platformApi', this.product.environment);

      return axios(`${platformApi}${this.streamConfig.tokenPath}`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'HTTP-X-SEVEN-CLUB-UUID': this.product.company,
          'HTTP-X-NAB-DP': 'Web',
          'SEVEN-LOCALE': this.language,
        },
        data: {
          stream: `${this.streamConfig.name}_${this.streamConfig.resolution.medium}`,
          pageUrl: this.page,
        },
      });
    },
    parseStreamSources(sources) {
      const parsedSources = [];
      for (let i = 0; i < sources.length; i += 1) {
        const sourceItem = {};
        sourceItem.src = sources[i].src;
        sourceItem.type = sources[i].type;
        parsedSources.push(sourceItem);
      }
      return parsedSources;
    },
    initialize() {
      const self = this;
      this.getStreamUrl()
        .then((response) => {
          self.playerOptions.sources = response;
          self.playerOptions.autoplay = true;
          self.playerInitialized = true;
        });
    },
    onPlayerReady() {
      if (!this.playerInitialized) {
        this.playerInitialized = true;
      }
    },
  },

  mounted() {
    this.initialize();
  },
};
</script>

<style lang="scss" scoped>
</style>
